import {
  createHubFilterStore,
  useGenericActiveProjectHubFilterCount,
  useGenericHasProjectHubFilters,
} from '@/shared/hooks/use-hub-filter-store';

export const useSubprojectHubFilterStore = createHubFilterStore();
export const useActiveSubprojectHubFilterCount = () =>
  useGenericActiveProjectHubFilterCount(useSubprojectHubFilterStore());
export const useHasSubprojectHubFilters = () =>
  useGenericHasProjectHubFilters(useSubprojectHubFilterStore());
